// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 768px)";
var _4 = "modal__paper-3TX9C";
var _5 = "modal__root-qbT-s";
var _6 = "mobile__paper-2aTQO";
var _7 = "root-SFT9U";
var _8 = "row-38aLR";
var _9 = "body-1zIuO";
var _a = "modalHeader-2IgUm";
var _b = "close-3c8BQ";
var _c = "withTabs-3mL7b";
var _d = "top_wrapper-i0tPS";
var _e = "mobileDialog__content-11KHB";
export { _1 as "__esModule", _2 as "mobile", _3 as "tabletMiddle", _4 as "modal__paper", _5 as "modal__root", _6 as "mobile__paper", _7 as "root", _8 as "row", _9 as "body", _a as "modalHeader", _b as "close", _c as "withTabs", _d as "top_wrapper", _e as "mobileDialog__content" }
export default { "__esModule": _1, "mobile": _2, "tabletMiddle": _3, "modal__paper": _4, "modal__root": _5, "mobile__paper": _6, "root": _7, "row": _8, "body": _9, "modalHeader": _a, "close": _b, "withTabs": _c, "top_wrapper": _d, "mobileDialog__content": _e }
